import axios, { endpoints } from "../../libs/axios";

export const authLogin = async (payload: {
  email: string;
  password: string;
}) => {
  try {
    const response = await axios.post(endpoints.auth.signIn, payload);
    return response.data;
  } catch (error) {
    console.error("Failed to log in", error);
    throw error;
  }
};

export const authRegister = async (payload: {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  country: string;
  role: string;
}) => {
  try {
    const response = await axios.post(endpoints.auth.signUp, payload);
    return response.data;
  } catch (error) {
    console.error("Failed to log in", error);
    throw error;
  }
};

export const getAddress = async (id: any) => {
  try {
    const response = await axios.get(endpoints.address);
    return response.data;
  } catch (error) {
    console.error("Failed to log in", error);
    throw error;
  }
};

export const deleteAddress = async (customerId: any, addressId: any) => {
  const response = await fetch(`/user-address/${customerId}/${addressId}`, {
    method: "DELETE",
  });
  if (!response.ok) {
    throw new Error("Failed to delete address");
  }
  return await response.json();
};

export const createAddress = async (
  id: any,
  payload: {
    address1: string;
    address2?: string;
    city: string;
    country: string;
    state: string;
    phone: string;
    postal_code: string;
    full_name: string;
    company?: string;
    tax_number?: string;
    coordinates?: { lat: number; lng: number };
    details?: { landmark?: string; floor?: string };
    default_billing?: boolean;
    default_shipping?: boolean;
  },
) => {
  const url = `${endpoints.postAddress}/${id}`;

  try {
    const response = await axios.post(url, payload);
    return response.data;
  } catch (error) {
    console.error("Failed to create address", error);
    throw error;
  }
};

export const updateUserProfileApi = async (
  userId: string,
  profileData: any,
) => {
  const url = `${endpoints.users}/${userId}`;
  try {
    const response = await axios.put(url, profileData);
    return response.data;
  } catch (error) {
    console.error("Failed to update user profile", error);
    throw error;
  }
};

export const sendOtpApi = async (email: string) => {
  const url = `${endpoints.auth.forgotPassword}`;
  try {
    const response = await axios.post(url, { email });
    return response.data;
  } catch (error) {
    console.error("Failed to send OTP", error);
    throw error;
  }
};

export const verifyOtpApi = async (payload: {
  email: string;
  newPassword: string;
  otp: string;
}) => {
  const url = `${endpoints.auth.verifyOtp}`;
  try {
    const response = await axios.post(url, payload);
    return response.data;
  } catch (error) {
    console.error("Failed to verify OTP", error);
    throw error;
  }
};

export const getCreditPointsApi = async (userId: string) => {
  const url = `${endpoints.users}`;
  try {
    const response = await axios.get(`${url}/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Failed to get credit points", error);
    throw error;
  }
};

export const getCreditHistoryApi = async (params?: {
  page?: number;
  limit?: number;
  type?: string;
}) => {
  try {
    const response = await axios.get(endpoints.creditPointsHistory, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Failed to get credit history", error);
    throw error;
  }
};
